// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-TitleSkeleton_cls1__wBIZG","cls2":"VeloCardForm-TitleSkeleton_cls2__tJihd VeloCardForm-TitleSkeleton_cls1__wBIZG"};